import { createContext, useContext } from 'react';

const FormPageAppContext = createContext(null);

/**
 * Оборачивает дерево, в котором используется FormPage / FormHeaderSpecialist.
 * Передаёт axios-подобный клиент, контексты URL и токена (как объекты createContext),
 * а также компоненты приложения.
 */
export function FormPageAppProvider({
  children,
  apiClient,
  apiUrlContext,
  authTokenContext,
  Loader,
  ConfirmationModal,
}) {
  const value = {
    apiClient,
    apiUrlContext,
    authTokenContext,
    Loader,
    ConfirmationModal,
  };
  return (
    <FormPageAppContext.Provider value={value}>
      {children}
    </FormPageAppContext.Provider>
  );
}

export function useFormPageApp() {
  const ctx = useContext(FormPageAppContext);
  if (!ctx) {
    throw new Error(
      'useFormPageApp: оберните приложение в <FormPageAppProvider> (см. @lk/form-renderer).'
    );
  }
  return ctx;
}
